
if(!window.SwymCallbacks) window.SwymCallbacks = [];

function swymCallbackFn(swat){
// your API calls go here
    document.addEventListener("swym:collections-loaded", function(){
        swat.initializeActionButtons("#AjaxinateContainer");
    })
}

window.SwymCallbacks.push(swymCallbackFn);

window.SwymCallbacks.push(function(){

  window.loadWishlistBubble();

  $('#add-to-wishlist').on('click', function(e) {
    e.preventDefault();
    if(SwymPageData){
      SwymPageData.et = 4;  // et 4 stands for wishlist event type
      _swat.addToWishList(SwymPageData, function(e){
        $('#add-to-wishlist').addClass('added');
        window.loadWishlistBubble();
      });
    }
  });

  window._swat.evtLayer.addEventListener(SwymTracker.JSEvents.addedToWishlist, function(e){
    window.loadWishlistBubble();
  });

  window._swat.evtLayer.addEventListener(SwymTracker.JSEvents.removedFromWishlist, function(e){
    window.loadWishlistBubble();
  });
});

window.loadWishlistBubble = function() {
  _swat.fetchWrtEventTypeET(function(products){
    $('.wishlist__bubble').html(products.length);
    if (products.length > 0) {
      $('.wishlist__bubble').addClass('wishlist__bubble--visible');
    } else {
      $('.wishlist__bubble').removeClass('wishlist__bubble--visible');
    }

  }, _swat.EventTypes.addToWishlist);
}

function setWishlistCookie(cname, cvalue, exdays) {
  var expires = "";
  if (exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      let expires = "expires="+d.toUTCString();
  }
  document.cookie = cname + "=" + cvalue + ";path=/;" + expires ;
}


var getProduct = async function(handle, variant) {
  var product= await jQuery.getJSON(window.Shopify.routes.root+'products/'+handle+'.js');

  var productVariants = product.variants;
  var productVariant = productVariants.find(element => element.id == variant);
  var [otherVariant] = product.variants.filter(() => this.id !== variant);
  var [category, fullName] = productVariant.name.split('|');
  var categoryNormalized = category.trim().toLowerCase();
  var name, size, color;
  [name, size] = fullName.split(' - ');
  color = name;
  var onSale = productVariant.compare_at_price && productVariant.compare_at_price > this.price;
  if(categoryNormalized === 'accessories') {
    size = 'Unique Size';
    [name, color] = fullName.split(' - ');
  }
  var productToAdd = {
    'name': name,
    'id': productVariant.sku,
    'variant_id': productVariant.id,
    'price': formatMoneyDataLayer(productVariant.price),
    'category': category,
    'variant': color,
    'dimension8': size,
    'dimension9': otherVariant && productVariant.price - otherVariant.price > 0 ? 'yes' : 'no',
    'dimension10': onSale ? 'sale' : 'no_discount',
    'dimension11': productVariant.available ? 'available' : 'not_available',
    'metric1': onSale ? formatMoneyDataLayer(productVariant.compare_at_price - productVariant.price) : formatMoneyDataLayer(0),
    'metric2': otherVariant ? formatMoneyDataLayer(productVariant.price - otherVariant.price) : formatMoneyDataLayer(0)
  };
  if (productToAdd) {
    return productToAdd;
  }

};

$('body').on('mousedown', '.singleremovebutton', function(){
  var variantId = $(this).attr('data-variantid');
  var productHandle = $(this).parents().find('.product[data-variantid='+variantId+'] .image a').attr('href');
  var cleanHandle = productHandle.split('?')[0].split('/')[2];
  var finalSku =  jQuery.getJSON(window.Shopify.routes.root+'products/'+cleanHandle+'.js', function(p){
      var productVariants = p.variants;
      $.each(productVariants, function(){
        if ($(this)[0].id == variantId) {
          window.finalSku =  $(this)[0].sku;
          return $(this)[0].sku;
        }
      });
  });
  window.dAgency.finalSku = finalSku;
});

$('#remove_modal').on('mousedown', '#modal_remove_button', function(){
  dataLayer.push({
      'event':'GAevent',
      'eventID':'20',
      'eventCategory':'product',
      'eventAction':'remove_from_wishlist',
      'eventLabel': window.finalSku
  });
});

var getProductInfo = function() {
  var [category, fullName] = $(this)[0].name.split('|');
  var categoryNormalized = category.trim().toLowerCase();
  var name, size, color;
  [name, size] = fullName.split(' - ');

  if(categoryNormalized === 'accessories') {
    size = 'Unique Size';
   [name, color] = fullName.split(' - ');
  }

  return {
    size,
    name,
    color,
    category
  };
}


var formatMoneyDataLayer =  function(amount) {
  var  currency = '$';
  try {
      var currentPriceWithCurrency = theme.Currency.formatMoney( amount );
      return currentPriceWithCurrency.replace(currency, '');
  } catch(e){
      console.error(e);
  }
}

var getProductHandle = function($productTile){
  var productHandle = $productTile.find('.image a').attr('href');
  return productHandle.split('?')[0].split('/')[2];
}

$('body').on('mousedown', '.product[data-variantid]', function(){
  var variantId = $(this).attr('data-variantid');
  var cleanHandle = getProductHandle($(this));
  var finalSku =  jQuery.getJSON(window.Shopify.routes.root+'products/'+cleanHandle+'.js', function(p){
    var productVariants = p.variants;
    $.each(productVariants, function(index){
      var [otherVariant] = p.variants.filter(() => this.id !== variantId);
      if (this.id == variantId) {
        var { size, name, color, category } = getProductInfo.apply(this);
        var onSale = this.compare_at_price && this.compare_at_price > this.price;
        setWishlistCookie('clicked_item', 'Wishlist');
        dataLayer.push({
          'event': 'productClick',
          'ecommerce': {
            'currencyCode': window.Shopify.currency.active,
            'click': {
              'actionField': {'list': 'Wishlist'},
              'products': [{
                'name': name,
                'id': this.sku,
                'variant_id': this.id,
                'price': formatMoneyDataLayer(this.price),
                'category': category,
                'variant': color,
                'position': index + 1,
                'dimension8': size,
                'dimension9': otherVariant && this.price - otherVariant.price > 0 ? 'yes' : 'no',
                'dimension10': onSale ? 'sale' : 'no_discount',
                'dimension11': this.available ? 'available' : 'not_available',
                'metric1': onSale ? formatMoneyDataLayer(this.compare_at_price - this.price) : formatMoneyDataLayer(0),
                'metric2': otherVariant ? formatMoneyDataLayer(this.price - otherVariant.price) : formatMoneyDataLayer(0)
              }]
            }
          }
        });
      }
    });
  });
});

$('body').on('mousedown', '.addsingleproduct[data-variantid]', function(e){
  e.preventDefault();
  e.stopPropagation();
  var variantId = $(this).attr('data-variantid');
  var productHandle = $(this).parents('.product').find('.image a').attr('href');
  var cleanHandle = productHandle.split('?')[0].split('/')[2];
  var finalSku =  jQuery.getJSON(window.Shopify.routes.root+'products/'+cleanHandle+'.js', function(p){
    var productVariants = p.variants;
    $.each(productVariants, function(index){
      var [otherVariant] = p.variants.filter(() => this.id !== variantId);
      if (this.id == variantId) {
        var { size, name, color, category } = getProductInfo.apply(this);
        var onSale = this.compare_at_price && this.compare_at_price > this.price;
        dataLayer.push({
          'event': 'addToCart',
          'addType': 'wishlist',
          'ecommerce': {
            'currencyCode': window.Shopify.currency.active,
            'add': {
              'actionField': {'list': 'Wishlist'},
              'products': [{
                'name': name,
                'id': this.sku,
                'variant_id': this.id,
                'price': formatMoneyDataLayer(this.price),
                'category': category,
                'variant': color,
                'position': index + 1,
                'dimension8': size,
                'dimension9': otherVariant && this.price - otherVariant.price > 0 ? 'yes' : 'no',
                'dimension10': onSale ? 'sale' : 'no_discount',
                'dimension11': this.available ? 'available' : 'not_available',
                'metric1': onSale ? formatMoneyDataLayer(this.compare_at_price - this.price) : formatMoneyDataLayer(0),
                'metric2': otherVariant ? formatMoneyDataLayer(this.price - otherVariant.price) : formatMoneyDataLayer(0)
              }]
            }
          }
        });
      }
    });
  });
});

$('body').on('mousedown', '#addallbutton', async function(e){
  e.preventDefault();
  e.stopPropagation();
  var $wishlistElements = $(document).find('#bookmarks .product[data-variantid]');
  var wishlistproductsData = [];

  for (let index = 0; index < $wishlistElements.length; index++) {
    const $productTile = $($wishlistElements[index]);
    var wishlistVariantId = $productTile.attr('data-variantid');
    var cleanHandle = getProductHandle($productTile);
    var productData = await getProduct(cleanHandle, wishlistVariantId );
    wishlistproductsData.push(productData);
  }

  dataLayer.push({
    'event': 'addToCart',
    'addType': 'wishlist',
    'ecommerce': {
      'currencyCode': window.Shopify.currency.active,
      'add': {
        'actionField': {'list': 'Wishlist'},
        'products': wishlistproductsData
      }
    }
  });
});

window.WishlistLoadedCallback = function () {
  var impressions = [];

  $('.product[data-variantid]').each(function () {
    var variantId = $(this).attr('data-variantid');
    var cleanHandle = getProductHandle($(this));
    jQuery.getJSON(window.Shopify.routes.root + 'products/' + cleanHandle + '.js', function (p) {
      var productVariants = p.variants;
      $.each(productVariants, function (index) {
        var [otherVariant] = p.variants.filter(() => this.id !== variantId);
        if (this.id == variantId) {
          var {size, name, color, category} = getProductInfo.apply(this);
          var onSale = this.compare_at_price && this.compare_at_price > this.price;
          impressions.push({
            'name': name,
            'id': this.sku,
            'price': formatMoneyDataLayer(this.price),
            'category': category,
            'variant': color,
            'position': index + 1,
            'dimension8': size,
            'dimension10': onSale ? 'sale' : 'no_discount',
            'dimension11': this.available,
            'metric1': onSale ? formatMoneyDataLayer(this.compare_at_price - this.price) : formatMoneyDataLayer(0),
            'metric2': otherVariant ? formatMoneyDataLayer(this.price - otherVariant.price) : formatMoneyDataLayer(0),
            'list': 'Wishlist',
          });
        }
      });
    }).done(function () {

      dataLayer.push({
        'event': 'productsImpression',
        'ecommerce': {
          'currencyCode': window.Shopify.currency.active,
          'impressions': impressions
        }
      });
    });
  });
};

